import * as yup from 'yup';

export type PasswordData = {
  password: string;
  confirmPassword: string;
};

export const passwordSchema = yup.object({
  password: yup
    .string()
    .min(8, 'Password must be at least 8 characters')
    .required('Password is required'),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password')], 'Passwords must match')
    .required('Please confirm your password'),
});

export const passwordDefaultValues: PasswordData = {
  password: '',
  confirmPassword: '',
};
